import { Suspense, useEffect } from "react";
import { useQueryLoader } from "react-relay";

import { Loader } from "@whoosh/design-system/src/components/display";

import {
  MultiSlotCourseFilters,
  MultiSlotCourseFiltersQueryString,
} from "./MultiSlotCourseFilters";
import { MultiSlotCourseFiltersQuery } from "./__generated__/MultiSlotCourseFiltersQuery.graphql";

type MultiSlotFiltersWrapperProps = {
  facilityId: string;
  currentCheckedCourses: Record<string, boolean> | null;
  setCurrentCheckedCourses: (courses: Record<string, boolean>) => void;
  isModalView?: boolean;
};

export const MultiSlotFiltersWrapper = ({
  facilityId,
  currentCheckedCourses,
  setCurrentCheckedCourses,
  isModalView,
}: MultiSlotFiltersWrapperProps) => {
  const [coursesQueryRef, loadQuery] =
    useQueryLoader<MultiSlotCourseFiltersQuery>(
      MultiSlotCourseFiltersQueryString
    );

  useEffect(() => {
    if (facilityId) {
      loadQuery(
        {
          facilityId: facilityId,
        },
        { fetchPolicy: "store-and-network" }
      );
    }
  }, [loadQuery, facilityId]);

  return (
    <Suspense fallback={<Loader />}>
      {coursesQueryRef ? (
        <MultiSlotCourseFilters
          queryRef={coursesQueryRef}
          isModalView={isModalView}
          currentCheckedCourses={currentCheckedCourses}
          setCurrentCheckedCourses={setCurrentCheckedCourses}
        />
      ) : null}
    </Suspense>
  );
};
